/*global require*/
/*eslint no-unused-vars: ["off"]*/
/*eslint no-unused-vars: ["off"]*/

/*global window, document, console, Promise*/

// Global variable for smooth scroll
let smoothScroll;

// Function to initialize the application
const initApp = async () => {
  console.log('Initializing application...');
  try {
    // Load jQuery and essential dependencies
    const $ = window.jQuery;

    const portalUrl = document.body.dataset.portalUrl;

    // Load jQuery UI components
    await Promise.all([
      loadScript(portalUrl + '/++theme++ugent/static/js/vendor/smooth-scroll.min.js'),
      loadScript(portalUrl + '/++theme++ugent/static/js/vendor/jquery-ui.min.js'),
    ]);

    // Load vendor bundle and other scripts
    await Promise.all([
      loadScript( portalUrl + '/++theme++ugent/static/js/vendor.min.js'),
      loadScript(portalUrl + '/++theme++ugent/js/faceted_view_extra.js'),
      loadScript(portalUrl + '/++theme++ugent/static/js/vendor/bootstrap-select.min.js'),
    ]);

    // Finally load theme scripts
    await loadScript(portalUrl + '/++theme++ugent/static/js/theme.min.js');

    return true;
  } catch (error) {
    console.error('Error initializing application:', error);
    return false;
  }
};

// Helper function to load scripts dynamically
const loadScript = (src) => {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = src;
    script.async = true;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error(`Failed to load script: ${src}`));
    document.head.appendChild(script);
  });
};

// Start initialization when DOM is loaded
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initApp);
} else {
  initApp();
}
